import { AuthGuard, redirectLoggedInTo, redirectUnauthorizedTo } from "@angular/fire/auth-guard";
import { Routes } from "@angular/router";

// Redirect functions for guards
const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(["login"]);
const redirectLoggedInToDashboard = () => redirectLoggedInTo(["dashboard"]);

export const routes: Routes = [
    {
        path: "login",
        loadComponent: () => import("./features/public/login/login.component").then((m) => m.LoginComponent),
        canActivate: [AuthGuard],
        data: { authGuardPipe: redirectLoggedInToDashboard }
    },
    {
        path: "dashboard",
        loadComponent: () => import("./features/dashboard/dashboard.component").then((m) => m.DashboardComponent),
        loadChildren: () => import("./features/dashboard/dashboard.routes"),
        canActivate: [AuthGuard],
        data: { authGuardPipe: redirectUnauthorizedToLogin }
    },
    {
        path: "",
        redirectTo: "/dashboard",
        pathMatch: "full"
    }
];
